module.exports = __webpack_public_path__ + "img/doc.6c9dcf85.svg";